<template>
  <div class="container">
    <!-- 数据列表 -->
    <div v-if="toView">
      <!-- 面包屑导航 -->
      <el-breadcrumb separator-class="el-icon-arrow-right" style="height: 30px; line-height: 30px">
        <el-breadcrumb-item><span style="cursor: pointer">报警历史数据</span></el-breadcrumb-item>
      </el-breadcrumb>
      <!-- 查询报警 -->
      <el-row type="flex" justify="space-between" class="query">
        <el-row type="flex"> 船舶名称：<el-input v-model="queryData.name" placeholder="请输入船舶名称"></el-input> </el-row>
        <el-row type="flex">
          状态：<el-select v-model="queryData.status" placeholder="请选择">
            <el-option v-for="item in queryOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          </el-select>
        </el-row>
        <el-row type="flex">
          报警时间：<el-date-picker v-model="queryData.startDate" type="date" placeholder="开始日期"> </el-date-picker
          ><el-date-picker v-model="queryData.endDate" type="date" placeholder="结束日期"> </el-date-picker>
        </el-row>
        <el-row type="flex">
          <el-button type="primary" @click="query">查询</el-button>
        </el-row>
      </el-row>
      <!-- 设备列表 -->
      <el-row class="table">
        <el-table :data="alarmList" border style="width: 100%; font-size: 1.2rem; border-radius: 5px">
          <el-table-column type="index" label="序号" width="60" align="center" />
          <el-table-column prop="warningContent" label="报警详情" align="center" />
          <el-table-column prop="shipName" label="船名" align="center" />
          <el-table-column prop="cameraName" label="报警位置" align="center" />
          <el-table-column prop="warningVideoPath" label="详情" align="center" width="60">
            <template #default="{ row }">
              <el-link @click="showVideo(row)">查看</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="warningTime" label="报警时间" width="140" align="center">
            <template #default="{ row }">
              <span>{{ new Date(row.warningTime).format("yyyy-MM-dd") }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="warningState" label="状态" width="100" align="center">
            <template #default="{ row }">
              <span>{{ row.warningState == 0 ? "未处理" : "已处理" }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="100" align="center" fixed="right">
            <template #default="{ row }">
              <el-button-group>
                <el-button size="mini" icon="el-icon-delete" type="danger" @click="del(row)">删除</el-button>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          style="display: flex; justify-content: end; margin: 10px 0px"
          :current-page="currentPage"
          :page-size="count"
          :page-sizes="[10, 20, 30, 50]"
          layout="total, sizes, prev, pager, next"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="currentChange"
        >
        </el-pagination>
      </el-row>
    </div>
    <!-- 数据详情 -->
    <div v-else>
      <!-- 面包屑导航 -->
      <el-breadcrumb separator-class="el-icon-arrow-right" style="height: 30px; line-height: 30px">
        <el-breadcrumb-item
          ><span
            style="cursor: pointer"
            @click="
              {
                ;(toView = true), (activeName = 'first')
              }
            "
            >报警历史数据</span
          ></el-breadcrumb-item
        >
        <el-breadcrumb-item><span style="cursor: pointer; font-weight: 700" @click="toView = false">报警详情</span></el-breadcrumb-item>
      </el-breadcrumb>
      <!-- 报警详情 -->
      <div class="alarmInfo">
        <el-tabs v-model="activeName" stretch>
          <el-tab-pane class="picuteBox" label="告警图片" name="first">
            <div style="width: 578px; height: 360px">
              <el-image
                style="width: 100%; height: 100%"
                :src="alarmInfo.warningImgPathOne"
                fit="cover"
                @click="showImg(alarmInfo.warningImgPathOne)"
              ></el-image>
            </div>
          </el-tab-pane>
          <el-tab-pane class="picuteBox" label="告警图片" name="second">
            <div style="width: 578px; height: 360px">
              <el-image
                style="width: 100%; height: 100%"
                :src="alarmInfo.warningImgPathTwo"
                fit="cover"
                @click="showImg(alarmInfo.warningImgPathTwo)"
              ></el-image>
            </div>
          </el-tab-pane>
          <el-tab-pane class="alarmvideo" label="告警视频" name="third">
            <video width="578" height="360" :src="alarmInfo.warningVideoPath" controls="controls" autoplay muted="muted"></video>
          </el-tab-pane>
          <el-tab-pane disabled></el-tab-pane>
          <el-tab-pane disabled></el-tab-pane>
          <div class="info-text">
            <div>告警名称：{{ alarmInfo.warningContent }}</div>
            <div>告警级别：{{ (alarmInfo.warningLev == 1 ? "一" : alarmInfo.warningLev == 2 ? "二" : "三") + "级预警" }}</div>
            <div>告警时间：{{ new Date(alarmInfo.warningTime).format("yyyy-MM-dd") }}</div>
            <div>告警船名：{{ alarmInfo.shipName }}</div>
            <div>告警场景：{{ alarmInfo.cameraName }}</div>
            <div>船舶位置：(经度:{{ alarmInfo.longitude }} 纬度:{{ alarmInfo.latitude }})</div>
            <div>船舶状态：{{ alarmInfo.shipState }}</div>
            <div>处理状态：{{ alarmInfo.warningState == 0 ? "未处理" : "已处理" }}</div>
          </div>
        </el-tabs>
        <div class="tab-footer">
          <el-button type="primary" @click="processingInformation = true">处 理</el-button>
          <el-button
            @click="
              {
                ;(toView = true), (activeName = 'first')
              }
            "
            >返 回</el-button
          >
        </div>
      </div>
      <!-- 处理信息弹框 -->
      <el-dialog v-model:visible="processingInformation" width="600px" top="12rem" @close="processingInformation = false">
        <div style="display: flex; align-items: center">
          <div style="width: 100px">处理意见：</div>
          <el-input v-model="alarmInfo.disposeContent" type="textarea" style="width: 75%" placeholder="请输入内容"></el-input>
        </div>
        <div style="display: flex; margin-top: 10px; align-items: center">
          <div style="width: 100px">结果反馈：</div>
          <el-input v-model="alarmInfo.resultContent" type="textarea" style="width: 75%" placeholder="请输入内容"></el-input>
        </div>
        <div style="display: flex; margin-top: 10px; align-items: center">
          <div style="width: 100px">是否误报：</div>
          <el-select v-model="alarmInfo.isFalseAlarm" placeholder="请选择">
            <el-option v-for="item in dealOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          </el-select>
        </div>
        <template #footer>
          <span class="dialog-footer">
            <el-button @click="processingInformation = false">取 消</el-button>
            <el-button type="primary" @click="updateDisposeContent">确 定</el-button>
          </span>
        </template>
      </el-dialog>
      <!-- 图片查看弹框 -->
      <el-image-viewer
        v-if="dialogVisibleImg"
        :z-index="9999"
        index="9999"
        :on-close="
          () => {
            dialogVisibleImg = false
          }
        "
        :url-list="[dialogImageUrl]"
      />
    </div>
  </div>
</template>

<script>
export default {
  // 组件名称
  name: "MyHistoricalAlarm",
  // 组件
  components: {
    "el-image-viewer": () => import("element-ui/packages/image/src/image-viewer"),
  },
  // 自定义属性
  props: {},
  // 数据
  data() {
    return {
      toView: true /* 查看详情 */,
      // 查询参数
      queryData: {
        name: "" /* 船舶名称 */,
        status: "" /* 选中状态 */,
        startDate: "" /* 开始日期 */,
        endDate: "" /* 结束日期 */,
      },
      // 状态选项
      queryOptions: [
        {
          value: "0" /* 选中值 */,
          label: "未处理" /* 选中标签 */,
        },
        {
          value: "1",
          label: "已处理",
        },
      ],
      // 报警列表
      alarmList: [],
      currentPage: 1 /* 当前页面 */,
      count: 10 /* 每页条数 */,
      total: 0 /* 总条数 */,
      activeName: "first" /* 选中标签 */,
      alarmInfo: {} /* 报警详情 */,
      processingInformation: false /* 处理信息弹框 */,
      // 处理选项
      dealOptions: [
        {
          value: "0",
          label: "否",
        },
        {
          value: "1",
          label: "是",
        },
      ],
      dialogVisibleImg: false /* 报警图片弹框 */,
      dialogImageUrl: "" /* 报警图片地址 */,
    }
  },
  // 计算属性
  computed: {},
  // 生命周期函数
  created() {
    this.getAlarmList()
  },
  // 方法
  methods: {
    // 条件查询
    query() {
      console.log(this.queryData)
    },
    // 获取报警列表
    getAlarmList() {
      let that = this
      this.$axios({
        method: "get",
        url: `/api/warningLog/list`,
        params: {
          page: this.currentPage,
          count: this.count,
        },
      })
        .then(function (res) {
          that.total = res.data.data.total
          const protocol = "https://api.lhmovie.com/alarmImg"
          res.data.data.list.forEach((item) => {
            ;["warningImgPathOne", "warningImgPathTwo", "warningVideoPath"].forEach((path) => {
              if (item[path]) {
                item[path] = item[path].replace(new URL(item[path]).origin, protocol)
              }
            })
          })
          that.alarmList = res.data.data.list
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    showImg(path) {
      this.dialogVisibleImg = true
      this.dialogImageUrl = path
    },
    // 切换页面
    currentChange(val) {
      this.currentPage = val
      this.getAlarmList()
    },
    // 切换页面条数
    handleSizeChange(val) {
      this.count = val
      this.getAlarmList()
    },
    // 删除报警
    del(row) {
      let that = this
      this.$confirm("确认删除该数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$axios({ method: "post", url: `/api/warningLog/delete`, params: { id: row.id } }).then((res) => {
          if (res.data.code === 200) {
            that.$message.success("删除成功！")
            this.getAlarmList()
          } else {
            that.$message.error(res.data.msg)
          }
        })
      })
    },
    // 查看详情
    showVideo(row) {
      console.log("row", row)

      const formatUrl = (path) => {
        if (!path) return
        return path.replace(new URL(path).origin, "https://api.lhmovie.com").split("?")[0]
      }

      const newData = {
        ...row,
        warningImgPathOne: formatUrl(row.warningImgPathOne),
        warningImgPathTwo: formatUrl(row.warningImgPathTwo),
        warningVideoPath: formatUrl(row.warningVideoPath),
      }
      // console.log("new", newData)

      this.alarmInfo = newData
      this.toView = false
    },
    // 更新报警状态
    updateDisposeContent() {
      let that = this
      this.$axios({
        method: "post",
        url: `/api/warningLog/updateDisposeContent`,
        params: {
          id: this.alarmInfo.id,
          disposeContent: this.alarmInfo.disposeContent,
          resultContent: this.alarmInfo.resultContent,
          isFalseAlarm: this.alarmInfo.isFalseAlarm,
        },
      }).then((res) => {
        if (res.data.code === 200) {
          that.$message.success("提交成功！")
          that.processingInformation = false
          this.getAlarmList()
        } else {
          that.$message.error(res.data.msg)
        }
      })
    },
  },
}
</script>

<style scoped>
.container {
  width: 100%;
}
.container .query {
  align-items: center;
  height: 70px;
  background-color: #fff;
  border-radius: 5px;
  padding: 0 20px;
}
.container .query > .el-row {
  white-space: nowrap;
  align-items: center;
}
.container .table {
  margin-top: 10px;
  background-color: #fff;
  border-radius: 5px;
}
.container .alarmInfo {
  background-color: #fff;
  min-height: 800px;
  position: relative;
}
.container .alarmInfo .picuteBox,
.container .alarmInfo .alarmvideo {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 20px;
}
.container .alarmInfo .info-text {
  display: flex;
  flex-flow: column;
  text-align: justify;
  line-height: 2;
  color: black;
  font-size: 1.1rem;
  position: absolute;
  top: 0;
  left: 620px;
}
.container .alarmInfo .info-text div:not(:first-child) {
  margin-top: 10px;
}
.container .alarmInfo .tab-footer {
  display: flex;
  justify-content: start;
  margin: 25px 0 20px 20px;
}
.container .alarmInfo .tab-footer .el-button {
  width: 150px;
  margin-right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/historicalAlarm.vue